import { defineMessages } from 'react-intl';

export const scope = 'app.components.TotalTestElapsedTime';

export default defineMessages({
  totalTimeElapsed: {
    id: `${scope}.totalTimeElapsed`,
    defaultMessage: 'Total Test Time: {totalTime}',
  },
});
